// @flow
/** @jsx h */
import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { styled } from 'goober';
import Header from '../../../../components/checkoutWidget/Header';
import { route } from 'preact-router';
import {
  useCheckoutContext,
  useCheckoutDispatchContext,
} from '../../../../storeProviders/checkoutWidgetStore';
import { device } from '../../../../utils/breakPoints';
import CancelModal from '../../../../components/checkoutWidget/CancelModal';
import {
  addRequestInterceptor,
  removeRequestInterceptor,
  addResponseInterceptor,
  removeResponseInterceptor,
} from '../../../../api/services/useRequest';
import WebFont from 'webfontloader';
import type {
  RequestInterceptorType,
  ResponseInterceptorType,
} from '../../../../api/services/useRequest';
import { validateAndSetClientIdCookie } from '../../../../tracking/helper';

import Match from 'preact-router/match';
import CommonErrorModal from '../../../commonErrorModal';
import { CHECKOUT_WIDGET_ID } from '../../../checkoutWidget/constants';
import LoaderScreen from '../../../checkoutWidget/LoaderScreen';
import { useCheckoutTracker } from '../../../checkoutWidget/tracker';
import { useDispatch } from 'react-redux';
import { WIDGET_STORE_HEADER } from '../../../../actionTypes';

const CheckoutWidgetUIContainer = styled('div')(
  (props) => `
  * {
   font-family: 'Inter', sans-serif;
  }
  --primaryCTAColor: ${props.checkoutTheme.primaryCTAColor};
   width: 100%;
   height: 100vh;
   background-color: transparent;
   display: flex;
   justify-content: center;
   align-items: center;
   -webkit-tap-highlight-color: transparent;
   -webkit-touch-callout: none;
   -webkit-user-select: none;
   -khtml-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
  .checkoutInnerContainer{
    margin: auto;
    background-color: #ffffff;
    width: 100%;
    height: 100vh;
    padding: 0px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }
  ${device.tabletS`
    .checkoutInnerContainer{
      height: 736px;
      max-width: 404px;
    }
  `}
  .checkoutInnerWrapper{
    padding: 16px 16px 0;
    flex-grow: 1;
    overflow: hidden;
  }
  .boxShadowWrapperContainer {
    background: #ffffff;
    box-shadow: 1px 1px 14px 1px rgba(0, 14, 40, 0.25);
    border-radius: 15px;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .boxShadowContainer {
    padding: 0 0 10px;
    position: static !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
  }
  .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label {
    color: #1A73E8 !important;
  }
  
  .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label {
    color: #1A73E8 !important;
  }
  
  .mdc-text-field--textarea.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-text-field__input:focus {
    border-color: #1A73E8 !important;
  }
  
   .mdc-text-field--textarea.mdc-text-field--focused:not(.mdc-text-field--disabled) {
    border-color: #1A73E8 !important;
  }
  
  .mdc-text-field .mdc-line-ripple {
    background-color: #1A73E8 !important;
  }
  
  .mdc-text-field:not(.mdc-text-field--disabled) {
    background-color: #ffffff !important;
  }

  .mdc-button:disabled {
    background-color: rgba(0, 0, 0, 0.12) !important;
    color: rgba(0, 0, 0, 0.37) !important;
  }
  
  .mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused
    .mdc-notched-outline__path {
    stroke: #1A73E8 !important;
  }
  .mdc-checkbox::before,
  .mdc-checkbox::after {
    background-color: #1A73E8 !important;
  }
  .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
  .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background {
    background-color: #1A73E8 !important;
    border-color: #1A73E8 !important;
  }
  .cwChildrenContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .innerContentContainer {
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 15px;
  }
  .innerContentContainer::-webkit-scrollbar,
  .innerContentContainer::-webkit-scrollbar-thumb,
  .innerContentContainer::-webkit-scrollbar-track {
    width: 6px;
    border: none;
    background: transparent;
  }
  
  .innerContentContainer::-webkit-scrollbar-button,
  .innerContentContainer::-webkit-scrollbar-track-piece,
  .innerContentContainer::-webkit-scrollbar-corner,
  .innerContentContainer::-webkit-resizer {
    display: none;
  }
  
  .innerContentContainer::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #B6B7B9;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  }
  
  .innerContentContainer::-webkit-scrollbar-track {
    background: #E2E2E2;
    border-left: 2px solid white;
    border-right: 2px solid white;
  }

`,
);

const HeaderContainer = styled('div')`
  position: sticky;
  top: 0;
  z-index: 3;
  width: 100%;
  max-width: 100%;
`;

const PoweredByLogoContainer = styled('div')`
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  margin: 0px;
  align-items: center;
  .powerdbyText {
    font-weight: 500;
    font-size: 12px;
    color: #a8a3a3;
  }
  .instacredLogo {
    margin-left: 10px;
    height: 12.5px;
    margin-top: -4px;
  }
`;

export const replaceInitialCheckoutRoute: (
  url: string,
  callback?: Function,
) => void = (url, callback) => {
  if (callback) callback(url);
  route(url + '?initial=true', true);
  route(url);
};

const CheckoutWidgetContainer = (props) => {
  const checkoutState = useCheckoutContext();
  const checkoutDispatch = useCheckoutDispatchContext();
  const checkoutTracker = useCheckoutTracker();
  const orderRef = useRef();
  const dispatch = useDispatch();
  const [shouldRender, setShouldRender] = useState(false);
  const [merchantOriginData, setMerchantOriginData] = useState();
  const [messageDataSet, setMessageDataSet] = useState();

  const isStringValidJSON = (stringJSON) => {
    let isValid = false;
    try {
      JSON.parse(stringJSON);
      isValid = true;
    } catch (e) {}
    return isValid;
  };

  useEffect(() => {
    checkoutState.orderDetails &&
      checkoutState.orderDetails.orderAmount &&
      checkoutTracker.trackAutomatic('ec_widget_initialized', undefined, {
        merchant_name: messageDataSet.merchantName,
        merchant_origin: merchantOriginData,
        txn_amount:
          checkoutState.orderDetails && checkoutState.orderDetails.orderAmount,
      });
  }, [checkoutState.orderDetails && checkoutState.orderDetails.orderAmount]);

  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Inter:400,500,600,700'],
      },
    });

    const messageListener = (e) => {
      const parentMerchantOrigin = document.referrer;

      let merchantOrigin;
      if (parentMerchantOrigin) {
        try {
          const checkOrigin = new URL(parentMerchantOrigin);
          merchantOrigin = checkOrigin.origin;
        } catch (e) {}
      }

      if (
        !merchantOrigin &&
        e.data &&
        typeof e.data === 'string' &&
        isStringValidJSON(e.data) &&
        e.isTrusted
      ) {
        const messageData = JSON.parse(e.data);
        merchantOrigin = messageData.merchantOrigin;
      }

      const isExpectedMerchantOrigin =
        !!merchantOrigin && merchantOrigin === e.origin;

      if (
        e.data &&
        typeof e.data === 'string' &&
        isStringValidJSON(e.data) &&
        isExpectedMerchantOrigin &&
        e.isTrusted
      ) {
        const messageData = JSON.parse(e.data);
        if (
          messageData.actionName === 'startPayment' &&
          messageData.orderToken
        ) {
          if (orderRef.current) {
            return;
          }

          setMerchantOriginData(merchantOrigin);
          setMessageDataSet(messageData);

          orderRef.current = {
            merchantKey: messageData.merchantKey,
            orderToken: messageData.orderToken,
            merchantOrigin,
            theme: messageData.themeData,
            icScope: messageData.icScope,
          };
          checkoutDispatch({
            type: 'START_PAYMENT',
            payload: {
              merchantData: {
                merchantKey: messageData.merchantKey,
                merchantURL: messageData.merchantURL,
                theme: messageData.themeData,
                merchantOrigin,
              },
            },
          });
          setShouldRender(true);
        }
      }
    };

    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  useEffect(() => {
    const clientId = validateAndSetClientIdCookie();
    const requestInterceptor: RequestInterceptorType = (config) => {
      config.headers = {
        ...config.headers,
        'ic-order-token': orderRef.current && orderRef.current.orderToken,
        'ic-merchant-key': orderRef.current && orderRef.current.merchantKey,
        'ic-origin': orderRef.current && orderRef.current.merchantOrigin,
        'client-id': clientId,
        'ic-merchant-sdk-scope': orderRef.current && orderRef.current.icScope,
      };
      dispatch({
        type: WIDGET_STORE_HEADER,
        payload: {
          'ic-merchant-key': orderRef.current && orderRef.current.merchantKey,
          'ic-origin': orderRef.current && orderRef.current.merchantOrigin,
          'ic-order-token': orderRef.current && orderRef.current.orderToken,
        },
      });
      return config;
    };

    addRequestInterceptor(requestInterceptor);

    const responseInterceptor: ResponseInterceptorType = (response) => {
      if (response.headers['ic-order-token']) {
        orderRef.current.orderToken = response.headers['ic-order-token'];
      }
      return response;
    };

    addResponseInterceptor(responseInterceptor);

    return () => {
      removeRequestInterceptor(requestInterceptor);
      removeResponseInterceptor(responseInterceptor);
    };
  });

  const pageLoadInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  const handleInitialPageBackClose = (url, path) => {
    const params = new URL(location.origin + url).searchParams;
    if (params.get('initial') === 'true') {
      route(path);
      checkoutDispatch({
        type: 'STORE_STATE',
        payload: {
          closeIconConfig: {
            showCloseIcon: true,
            shouldShowCancellationPopup: true,
            showCancellationPopup: true,
          },
        },
      });
    }

    return null;
  };

  const checkoutTheme = {
    ...(orderRef.current && {
      primaryCTAColor:
        (orderRef.current.theme && orderRef.current.theme.primaryColor) ||
        '#003c7c',
    }),
  };

  return (
    pageLoadInIframe() && (
      <Fragment>
        <Match>
          {({ url, path }) => handleInitialPageBackClose(url, path)}
        </Match>
        <CheckoutWidgetUIContainer checkoutTheme={checkoutTheme || {}}>
          <div className='checkoutInnerContainer' id={CHECKOUT_WIDGET_ID}>
            <CancelModal />
            <CommonErrorModal />
            <HeaderContainer>
              <Header />
            </HeaderContainer>
            <div className='checkoutInnerWrapper'>
              <div className='cwChildrenContainer'>
                {!shouldRender ? <LoaderScreen /> : props.children}
              </div>
            </div>
            <PoweredByLogoContainer>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '16px 0px',
                  alignItems: 'center',
                }}>
                <div className='powerdbyText'>Powered by</div>
                <img
                  alt='icLogo'
                  src='https://iccdn.in/img/instacred-v1.0.svg'
                  className='instacredLogo'
                />
              </div>
            </PoweredByLogoContainer>
          </div>
        </CheckoutWidgetUIContainer>
      </Fragment>
    )
  );
};

export default CheckoutWidgetContainer;



// WEBPACK FOOTER //
// ./components/partial/container/checkoutWidgetConatiner/index.js